/* eslint-disable no-console */
import React, { Component } from "react";
import { listVehicleTypes, getVehicle } from "../../graphql/queries";
import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import withStyles from "@material-ui/core/styles/withStyles";
import Avatar from "@material-ui/core/Avatar";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Select from "react-select";
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  ListGroup,
  ListGroupItem
} from "reactstrap";

import { connect } from "react-redux";
import { utilGetVehicleImage } from "../../common/util";

import { toast } from "react-toastify";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { styles } from "../../assets/css/styles";
import iconImage from "../../assets/img/truck.png";
import InspectionsTable from "../../components/Table/inspection-table";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Modal from "@material-ui/core/Modal";
import { Typography } from "@material-ui/core";
import { findLastIndex } from "lodash";
import NewVehicleDetail from "./NewVehicleDetail";
import { Storage } from "aws-amplify";
class VehicleDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeName: "",
      createdAt: "",
      customerVehicleId: "",
      Id: "",
      license: "",
      locationLat: "",
      locationLong: "",
      make: "",
      model: "",
      updatedAt: "",
      vehicleCustomerId: "",
      vehicleYear: "",
      vehicleType: {},
      vIN: "",
      selectedOptions: [],
      activeTab: 1,
      inspections: [],
      open: false,
      defects: [],
      selectedDefect: {},
      vehicleStatus: "",
      defectsCount: 0,
      OnTheFly: 0,
      Divr: 0,
      InspDue: "",
      newView: false,
      vehicle: null,
      initialFetch: true,
      vehicleData: ""
    };
  }

  onTextChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  notify = msg => toast(msg);

  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("../../company");
  };
  loadVehTypes = async () => {
    const { client } = this.props;
    const vehTypesList = await client.query({
      query: gql(listVehicleTypes),
      fetchPolicy: `network-only`
    });
    const vehTypesArray = new Array();
    vehTypesList.data.listVehicleTypes.items.map(itm => {
      let vehType = {};
      vehType.value = itm.id;
      vehType.label = itm.vehicleType;
      vehTypesArray.push(vehType);
      return true;
    });
    this.setState({ selectedOptions: vehTypesArray }); //=vehTypesArray.slice();
  };
  loadVehicle = async id => {
    spinnerService.show("mySpinner");
    //
    const { client } = this.props;
    const vehicle = await client.query({
      query: gql(getVehicle),
      fetchPolicy: `network-only`,
      variables: { id }
    });
    
    this.setState({ vehicle });
    const vehInfo = vehicle.data.getVehicle;
    
    let vehDefectCount = 0;
    const insp = vehInfo.nextInspectionDue;
    const regType = vehInfo.customer.registeredInspectionType;
    let vehObj = {
      customerVehicleId: vehInfo.customerVehicleId,
      customer: vehInfo.customer.id,
      activeDefsData: [],
      archiveDefsData: [],
      inspectionsData: {
        regType,
        deactivateBIT: vehInfo.deactivateBIT,
        deactivateDOT: vehInfo.deactivateDOT,
        companyName: vehInfo.customer.companyName,
        customerVehicleId: vehInfo.customerVehicleId,
        customerAddresses: vehInfo.customer.customerAddresses[0].address,
        // nextInsp1: insp.length > 0 ? insp[0].nextDueDate : "No Date Mentioned",
        // nextInsp2: insp.length > 1 ? insp[1].nextDueDate : "No Date Mentioned",
        data: []
      }
    };
    if (insp) {
      await insp.map(i => {
        if (i.inspectionType === "BIT_90DAY_INSPECTION") {
          vehObj.inspectionsData.nextBIT = i.nextDueDate;
        } else if (i.inspectionType === "DOT_ANNUAL_INSPECTION") {
          vehObj.inspectionsData.nextDOT = i.nextDueDate;
        } else {
          vehObj.inspectionsData.nextDOT = "No Date Mentioned";
          vehObj.inspectionsData.nextBIT = "No Date Mentioned";
        }
      });
    }
    await vehInfo.defectsByStatus.items.map(defect => {
      let temp = [];
      if (!["REPAIRED", "REVOKED"].includes(defect.status)) {
        if (defect.defectUploads && defect.defectUploads.length > 0) {
          defect.defectUploads.map(async img => {
            temp.push(await Storage.get(img.key));
          });
        }
        vehObj.activeDefsData.push({
          id: defect.id,
          customer: vehInfo.customer.id,
          reportedDateTime: defect.reportedDateTime,
          sourceType: defect.sourceType,
          status: defect.status,
          defectDesc: defect.defectDesc,
          defectType: defect.defectType,
          defectUploads: temp,
          redTag: defect.redTag,
          repairNotes: defect.repairNotes,
          partsUsedInRepair: defect.partsUsedInRepair
        });
      }
    });
    await vehInfo.defectsByStatus.items.map(defect => {
      let temp = [];
      if (["REPAIRED", "REVOKED"].includes(defect.status)) {
        if (defect.defectUploads && defect.defectUploads.length > 0) {
          defect.defectUploads.map(async img => {
            temp.push(await Storage.get(img.key));
          });
        }
        vehObj.archiveDefsData.push({
          id: defect.id,
          customer: vehInfo.customer.id,
          reportedDateTime: defect.reportedDateTime,
          sourceType: defect.sourceType,
          status: defect.status,
          defectDesc: defect.defectDesc,
          defectType: defect.defectType,
          defectUploads: temp,
          redTag: defect.redTag,
          repairNotes: defect.repairNotes,
          partsUsedInRepair: defect.partsUsedInRepair
        });
      }
    });
    await vehInfo.inspections.items.map(ins => {
      vehObj.inspectionsData.data.push({
        id: ins.id,
        customer: vehInfo.customer.id,
        endAt: ins.endAt,
        nextInspectionDue: ins.nextInspectionDue,
        inspectionType: ins.inspectionType
      });
    });
    vehObj.defectCount = vehDefectCount;
    this.setState({
      vehicleData: vehObj
    });

    let tempArr = vehicle.data.getVehicle.defects.items.filter(
      val => val.sourceType === "ONTHEFLY"
    );
    let tempArr1 = vehicle.data.getVehicle.defects.items.filter(
      val => val.sourceType !== "ONTHEFLY"
    );
    this.setState({
      typeName: vehicle.data.getVehicle.vehicleType
        ? {
            label: vehicle.data.getVehicle.vehicleType.vehicleType,
            value: vehicle.data.getVehicle.id
          }
        : null,
      customerVehicleId: vehicle.data.getVehicle.customerVehicleId,
      Id: vehicle.data.getVehicle.id,
      license: vehicle.data.getVehicle.license,
      make: vehicle.data.getVehicle.make,
      model: vehicle.data.getVehicle.model,
      currentMileage: vehicle.data.getVehicle.currentMileage,
      updatedAt: "",
      vehicleType: vehicle.data.getVehicle.vehicleType,
      vehicleYear: vehicle.data.getVehicle.vehicleYear,
      vIN: vehicle.data.getVehicle.VIN,
      specialInstructions: vehicle.data.getVehicle.specialInstructions,
      inspections: vehicle.data.getVehicle.inspections.items,
      defects: vehicle.data.getVehicle.defects.items,
      vehicleStatus: vehicle.data.getVehicle.vehicleStatus,
      defectsCount: vehicle.data.getVehicle.defects.items.length,
      OnTheFly: tempArr.length,
      Divr: tempArr1.length,
      InspDue:
        vehicle.data.getVehicle.nextInspectionDue &&
        vehicle.data.getVehicle.nextInspectionDue.length > 0
          ? vehicle.data.getVehicle.nextInspectionDue[0].nextDueDate
          : "",
      newView: true,
      initialFetch: false
    });
    spinnerService.hide("mySpinner");
  };
  async componentDidMount() {
    if (this.props.data === undefined || this.props.data.length === 0) {
      await this.loadVehicle(this.props.match.params.vId);
    } else {
      await this.loadVehicle(this.props.match.params.vId);
      // this.fetchFromStore(this.props.match.params.vId);
    }
    await this.loadVehTypes();
  }

  fetchFromStore = id => {
    this.props.data.customer.vehicles.items.map(Item => {
      if (Item.id === id) {
        let tempArr = Item.defects.items.filter(
          val => val.sourceType === "ONTHEFLY"
        );
        let tempArr1 = Item.defects.items.filter(
          val => val.sourceType !== "ONTHEFLY"
        );
        var typeName = null;
        if (Item.vehicleType !== undefined && Item.vehicleType !== null) {
          typeName = {
            label: Item.vehicleType.vehicleType,
            value: Item.vehicleType.id
          };
        }

        this.setState({
          typeName,
          defectsCount: Item.defects.items.length,
          OnTheFly: tempArr.length,
          Divr: tempArr1.length,
          customerVehicleId: Item.customerVehicleId,
          Id: Item.id,
          license: Item.license,
          make: Item.make,
          model: Item.model,
          updatedAt: "",
          vehicleYear: Item.vehicleYear,
          vIN: Item.VIN,
          vehicleType: Item.vehicleType,
          specialInstructions: Item.specialInstructions,
          vehicleStatus: Item.vehicleStatus,
          inspections: Item.inspections.items,
          defects: Item.defects.items,
          InspDue: Item.nextInspectionDue[0].nextDueDate
        });
      }
    });
  };
  handleChange = typeName => {
    this.setState({ typeName });
  };

  toggle = tab => {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
  };

  handleOpen = () => {
    this.setState({ open: !this.state.open });
  };

  DefectDetailModel = () => {
    let {
      redTag,
      defectType,
      sourceType,
      status,
      repairedDateTime,
      assignedAtDateTime,
      defectDesc,
      repairNotes
    } = this.state.selectedDefect;
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={() => this.handleOpen()}
        >
          <div
            style={{
              position: "absolute",
              width: 600,
              backgroundColor: "white",
              // border: '2px solid #000',
              boxShadow: 5,
              padding: 25,
              top: 100,
              left: 450
            }}
          >
            <h4 id="simple-modal-title">Defect Detail</h4>
            <Row>
              <Col sm={6}>Defect type :</Col>
              <Col sm={6}>{defectType}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Defect status :</Col>
              <Col sm={6}>{status}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Assigned date&time :</Col>
              <Col sm={6}>{assignedAtDateTime}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Reported date&time :</Col>
              <Col sm={6}>{repairedDateTime}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Source type :</Col>
              <Col sm={6}>{sourceType}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Red Tage :</Col>
              <Col sm={6}>{redTag ? "true" : "false"}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Repair Notes :</Col>
              <Col sm={6}>{repairNotes}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={6}>Defect discription :</Col>
              <Col sm={6}>{defectDesc}</Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col sm={{ size: "4", offset: "4" }}>
                <Button
                  size="lg"
                  color="primary"
                  block
                  onClick={() => this.handleOpen()}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    );
  };

  DefectTable = () => {
    let { defects } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Defect Type</TableCell>
            {/* <TableCell>Reporteds Date</TableCell>
            <TableCell>Assigned Date</TableCell> */}
            <TableCell>Repair Notes</TableCell>
            <TableCell>Defect Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {defects.map(item => {
            let {
              defectType,
              reportedDateTime,
              assignedAtDateTime,
              repairNotes
            } = item;
            return (
              <TableRow>
                <TableCell>{defectType}</TableCell>
                {/* <TableCell>{reportedDateTime}</TableCell>
                <TableCell>{assignedAtDateTime}</TableCell> */}
                <TableCell>{repairNotes}</TableCell>
                <TableCell
                  onClick={() => {
                    this.setState({ selectedDefect: item }, () => {
                      this.handleOpen();
                    });
                  }}
                >
                  Details
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };
  InspectionsTable = () => {
    let { inspections, customerVehicleId } = this.state;
    return (
      <Table style={{ width: "90%" }}>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Due Next</TableCell>
            <TableCell>Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inspections.map(item => {
            return (
              <TableRow>
                <TableCell>{customerVehicleId}</TableCell>
                <TableCell>{item.startAt}</TableCell>
                <TableCell>{item.nextInspectionDue}</TableCell>
                <TableCell onClick={() => this.handleOpen()}>Details</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };
  render() {
    const {
      activeTab,
      make,
      model,
      currentMileage,
      customerVehicleId,
      vehicleType,
      vehicleStatus,
      vIN,
      vehicleYear,
      newView
    } = this.state;
    const { classes } = this.props;
    let iconSrc = vehicleType
      ? utilGetVehicleImage(vehicleType.vehicleCategory)
      : null;
    return (
      <div style={{ marginTop: -25 }}>
        <main ref="main" App>
          {this.DefectDetailModel()}
          {newView ? (
            <div>
              {/* <Typography
                onClick={() => {
                  this.setState({
                    newView: false
                  });
                }}
              >
                Old View
              </Typography> */}
              <NewVehicleDetail
                usrGrp={
                  this.props.user.signInUserSession.idToken.payload[
                    "cognito:groups"
                  ][0]
                }
                // data={this.state.vehicle}
                data={this.state.vehicleData}
                img={iconSrc}
                client={this.props.client}
                history={this.props.history}
                focus={
                  this.props.location.state !== undefined
                    ? this.props.location.state.focus
                    : this.props.location.focus
                }
              />
            </div>
          ) : (
            !this.state.initialFetch && (
              <Container style={{ padding: 20 }}>
                {/* <Typography
                onClick={() => {
                  this.setState({
                    newView: true
                  });
                }}
              >
                New View
              </Typography> */}
                <Row
                  style={{
                    backgroundColor: "white",
                    marginBottom: "1px",
                    padding: 10
                  }}
                >
                  <Col sm={4}>
                    <Row>
                      <Col
                        sm={4}
                        style={{
                          paddingTop: 20,
                          textAlign: "right",
                          verticalAlign: "middle"
                        }}
                      >
                        {iconSrc && (
                          <img
                            src={iconSrc}
                            style={{ width: "100%", height: "80%" }}
                          ></img>
                        )}
                      </Col>
                      <Col
                        sm={8}
                        style={{
                          textAlign: "left",
                          paddingLeft: 0,
                          paddingTop: 15
                        }}
                      >
                        {vehicleType && <h4>{vehicleType.vehicleCategory}</h4>}
                        {vehicleType && (
                          <p style={{ fontSize: 14, marginTop: -15 }}>
                            {vehicleType.vehicleType}
                          </p>
                        )}
                        <p style={{ fontSize: 14, marginTop: -15 }}>
                          <b>
                            ID: {customerVehicleId} ({vehicleStatus})
                          </b>
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={8}>
                    <div style={{ float: "right" }}>
                      <Nav>
                        <NavItem>
                          <NavLink style={{ color: "black" }} href="#">
                            {/* <div>Inspections</div> */}
                            <div>Next Due Date </div>
                            <div> {this.state.InspDue} </div>
                            {/* <div>0 defects in last inspection</div> */}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink style={{ color: "black" }} href="#">
                            <div>{this.state.defectsCount} Active Defects</div>
                            <div>{this.state.Divr} DVIR</div>
                            <div>
                              {this.state.OnTheFly} On the Fly and Inspection
                            </div>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col
                    sm={4}
                    style={{ backgroundColor: "white", paddingTop: 10 }}
                  >
                    <ListGroup>
                      <ListGroupItem disabled tag="a" href="#">
                        Vehicle Details
                      </ListGroupItem>
                      {make && (
                        <ListGroupItem tag="a" href="#">
                          Make: {make}
                        </ListGroupItem>
                      )}

                      {model && (
                        <ListGroupItem tag="a" href="#">
                          Model: {model}
                        </ListGroupItem>
                      )}
                      {currentMileage && (
                        <ListGroupItem tag="a" href="#">
                          Mileage: {currentMileage}
                        </ListGroupItem>
                      )}
                      {vIN && (
                        <ListGroupItem tag="a" href="#">
                          VIN:
                          {vIN.slice(0, 9).toString()}
                          <strong
                            style={{ fontSize: 18, fontWeight: "bolder" }}
                          >
                            {vIN.slice(9, 11).toString()}
                          </strong>
                          <strong
                            style={{ fontSize: 18, fontWeight: "bolder" }}
                          >
                            <i>{vIN.slice(11, 17).toString()}</i>
                          </strong>
                        </ListGroupItem>
                      )}
                      {vehicleYear && (
                        <ListGroupItem tag="a" href="#">
                          Year: {vehicleYear}
                        </ListGroupItem>
                      )}
                      <ListGroupItem
                        tag="a"
                        href="#"
                        style={{ textAlign: "right" }}
                      >
                        <Button
                          color="primary"
                          onClick={() =>
                            this.props.history.push(
                              `/company/edit/${this.props.match.params.vId}`
                            )
                          }
                        >
                          Edit
                        </Button>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                  <Col
                    sm={8}
                    style={{
                      backgroundColor: "white",
                      paddingTop: 10,
                      paddingRight: 5
                    }}
                  >
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={activeTab === 1 && "active"}
                          onClick={() => {
                            this.toggle(1);
                          }}
                        >
                          Inspections
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={activeTab === 2 && "active"}
                          onClick={() => {
                            this.toggle(2);
                          }}
                        >
                          Defects
                        </NavLink>
                      </NavItem>
                    </Nav>
                    {activeTab === 1 && this.InspectionsTable()}
                    {activeTab === 2 && this.DefectTable()}
                  </Col>
                </Row>
              </Container>
            )
          )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.vehicles.loading,
    data: state.vehicles.data
  };
};
export default VehicleDetails = connect(
  mapStateToProps,
  null
)(withStyles(styles)(VehicleDetails));



// WEBPACK FOOTER //
// ./src/views/Company/VehicleDetails.js